import React, { useState } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Pizza } from "ceicons";
import { useTranslation } from "ceco-polyglot";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../../../environment";
import { isEmpty } from "lodash";

export default function SectionModal(props) {
  const { trigger, edit = false, recipeId, section, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const t = useTranslation();
  function createSection() {
    return new Promise((resolve, reject) => {
      const variables = { recipeId: recipeId, ...formData };

      commitMutation(environment, {
        mutation: SectionModalCreateMutation,
        variables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
        // configs: [
        //   {
        //     type: "RANGE_ADD",
        //     parentID: recipeId,
        //     connectionInfo: [
        //       {
        //         key: "SectionsList_section",
        //         rangeBehavior: "append",
        //       },
        //     ],
        //     edgeName: "recipeSection",
        //   },
        // ],
        updater: (store) => {
          //TODO arreglar updater, con la opcion de arriba funciona a medias, me crea la sección pero con datos undefined.
          const payload = store.getRootField("recipeSectionCreate");
          // const recipeSection = payload.getLinkedRecord("recipeSection");
          // const name = recipeSection.getValue("name");
          // const id = recipeSection.getValue("id");

          const recipe = store.get(recipeId);
          const sectionField = recipe.getLinkedRecord("section");
          const edges = sectionField.getLinkedRecords("edges") || [];
          const newSectionsEdges = [...edges, payload];
          sectionField.setLinkedRecords(newSectionsEdges, "edges");
          // console.log(edges);
          // // console.log("recipe", recipe);
          // // const newSections = [...sections, payload];
          // // console.log("newSections", newSections);
          // // recipe.setLinkedRecords(newSections, "sections");
        },
      });
    });
  }
  function editSection() {
    return new Promise((resolve, reject) => {
      const variables = { sectionId: section.id, ...formData };

      commitMutation(environment, {
        mutation: SectionModalUpdateMutation,
        variables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }
  function handleChange(evt) {
    const { value } = evt.target;
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }

  const onSubmit = async () => {
    // createSection().then(() => {
    //   setModalOpen(false);
    // });
    if (validateForm()) {
      const action = !edit ? createSection : editSection;
      const msg = !edit
        ? t("message.added_section")
        : t("message.edited_section");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e?.errors[0]?.message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    if (!formData?.name) {
      errors = { ...errors, name: t("form.errorRequired") };
    }
    if (!isEmpty(errors)) {
      setFormErrors(errors);
      return false;
    }

    return true;
  };

  return (
    <BasicModal
      size="tiny"
      className="single-button"
      title={
        <div className="modalTitle">
          <Pizza />
          {!edit ? t("modalTitle.createSection") : t("modalTitle.editSection")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit ? setFormData({ ...section }) : setFormData({});
        },
      })}
      actions={
        <Button
          type="submit"
          onClick={() => {
            onSubmit();
          }}
          primary
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form>
        {/* <ImageDropzone /> */}
        <Form.Input
          name="name"
          error={formErrors && formErrors["name"]}
          value={formData.name || ""}
          label={t("form.name")}
          placeholder={t("form.name")}
          onChange={handleChange}
        />
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}
const SectionModalCreateMutation = graphql`
  mutation SectionModalCreateMutation($recipeId: ID!, $name: String!) {
    recipeSectionCreate(input: { recipe: $recipeId, name: $name }) {
      recipeSection {
        id
        name
      }
    }
  }
`;
const SectionModalUpdateMutation = graphql`
  mutation SectionModalUpdateMutation($sectionId: ID!, $name: String!) {
    recipeSectionUpdate(input: { id: $sectionId, name: $name }) {
      recipeSection {
        id
        name
      }
    }
  }
`;
